// Generated by ReScript, PLEASE EDIT WITH CARE

var empty_anchors = [];
var empty_offset = [];
function empty_registerSection(param) {}
function empty_setOffset(param) {}
function empty_onScrollDiv(param, param$1) {}
function empty_onScrollWindow(param) {}
function empty_onClick(param) {
  return false;
}
var empty = {
  anchors: empty_anchors,
  offset: empty_offset,
  registerSection: empty_registerSection,
  highlightRef: undefined,
  scrollToRef: undefined,
  setOffset: empty_setOffset,
  onScrollDiv: empty_onScrollDiv,
  onScrollWindow: empty_onScrollWindow,
  onClick: empty_onClick
};
var Category;
export { Category, empty };
/* No side effect */